import { render, staticRenderFns } from "./SpotList.vue?vue&type=template&id=f35ef3ce&"
import script from "./SpotList.vue?vue&type=script&lang=js&"
export * from "./SpotList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports